import { CloseXButton } from "@atomic";
import { Colors, Spacing } from "@constants";
import { GlobalState, ModalActions } from "@redux";
import React from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Modal,
  ViewStyle,
  TouchableWithoutFeedback,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";

interface IProps {
  children?: React.ReactNode;
  forwardCloseTestID?: string;
  forwardTestID?: string;
  style?: ViewStyle | ViewStyle[];
  closeXButtonStyle?: ViewStyle;
  closeXContainerStyle?: ViewStyle;
  isOpen?: boolean;
  handleClose?: () => void;
  isMobile?: boolean;
  isFullScreen?: boolean;
  closeOnClickOutside?: boolean;
  isCenter?: boolean;
  paddingVertical?: number | undefined;
  paddingHorizontal?: number | undefined;
  isHideCloseButton?: boolean;
  customComponentCloseButton?: React.ReactElement;
  showsVerticalScrollIndicator?: boolean;
  bodyStyle?: ViewStyle | ViewStyle[];
}
export const ModalTemplate: React.FC<IProps> = React.memo(
  ({
    children,
    style,
    closeXButtonStyle,
    closeXContainerStyle,
    forwardCloseTestID,
    forwardTestID,
    isOpen,
    handleClose,
    isMobile,
    isFullScreen,
    paddingVertical,
    paddingHorizontal,
    isHideCloseButton,
    closeOnClickOutside = false,
    isCenter,
    customComponentCloseButton,
    showsVerticalScrollIndicator = false,
    bodyStyle
  }) => {
    const dispatch = useDispatch();
    const open = useSelector((state: GlobalState) => state?.modal?.open);

    const styles = React.useMemo(
      () =>
        _styles(
          isMobile,
          isFullScreen,
          isCenter,
          paddingVertical,
          paddingHorizontal
        ),
      [isMobile, isFullScreen, isCenter, paddingVertical, paddingHorizontal]
    );

    const handleCloseModal = () => {
      if (handleClose) handleClose();
      else dispatch(ModalActions.setOpen(false));
    };

    return (
      <Modal
        testID={forwardTestID}
        transparent={true}
        visible={isOpen !== undefined ? isOpen : open}
        style={{height: "100%"}}
      >
        <View style={styles.container}>
          <TouchableWithoutFeedback
            onPress={closeOnClickOutside ? handleClose : undefined}
          >
            <View style={styles.modalBackground} />
          </TouchableWithoutFeedback>
          <View style={[styles.body, bodyStyle]}>
            <ScrollView
              persistentScrollbar={showsVerticalScrollIndicator}
              showsVerticalScrollIndicator={showsVerticalScrollIndicator}
              style={[styles.loginContainer, style]}
              contentContainerStyle={{ paddingBottom: Spacing.L }}
            >
              {!isHideCloseButton && !customComponentCloseButton && (
              <View style={[styles.closeBtnDiv, closeXContainerStyle]}>
                <CloseXButton
                  forwardTestID={forwardCloseTestID}
                  callback={handleCloseModal}
                  closeXButtonStyle={closeXButtonStyle}
                />
              </View>
            )}
            {!!customComponentCloseButton && (
              <View style={[styles.closeBtnDiv, closeXContainerStyle]}>
                {customComponentCloseButton}
              </View>
            )}
              {children}
            </ScrollView>

          </View>
        </View>
      </Modal>
    );
  }
);

const _styles = (
  isMobile?: boolean,
  isFullScreen?: boolean,
  isCenter?: boolean,
  paddingVertical: number | undefined = Spacing.XL,
  paddingHorizontal: number | undefined = Spacing.L
) =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    body: {
      ...(isCenter
        ? { position: "absolute" }
        : {
          flex: 1,
          marginTop: 80,
          marginBottom: isMobile ? 0 : 50
        }),
    },
    modalBackground: {
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundColor: Colors.foodiBlack,
      opacity: 0.5,
    },
    loginContainer: {
      flexGrow: isMobile ? 1 : 0,
      paddingVertical: paddingVertical,
      paddingHorizontal: paddingHorizontal,
      width: isMobile ? "100%" : 520,
      maxWidth: 640,
      maxHeight: isFullScreen
        ? isMobile ? "100%" : "95vh"
        : isMobile ? "90%" : "80vh",
      backgroundColor: Colors.white,
      borderRadius: isMobile ? 10 : 8,
    },
    closeBtnDiv: {
      position: "absolute",
      top: 24,
      right:24,
      zIndex: 1,
    },
  });
